/* eslint-disable max-classes-per-file */
import { AgmCoreModule } from '@agm/core';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatPseudoCheckboxModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileUploadModule as NgxFileUploadModule } from '@iplab/ngx-file-upload';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { FormlyModule, FORMLY_CONFIG } from '@ngx-formly/core';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { FormlyMatToggleModule } from '@ngx-formly/material/toggle';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FilePickerModule } from 'ngx-awesome-uploader';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { ScWidgetModule } from '../sc-widget/sc-widget.module';
import { AutocompleteValueParserPipe } from './sc-formly-fields/field-autocomplete/autocomplete-value-parser.pipe';
import { FieldAutocompleteComponent } from './sc-formly-fields/field-autocomplete/field-autocomplete.component';
import { FieldButtonToggleComponent } from './sc-formly-fields/field-button-toggle/field-button-toggle.component';
import { FieldCheckboxComponent } from './sc-formly-fields/field-checkbox/field-checkbox.component';
import { FieldDatetimePickerComponent } from './sc-formly-fields/field-datetime-picker/field-datetime-picker.component';
import { FieldDynamicComponent } from './sc-formly-fields/field-dynamic/field-dynamic.component';
import { FieldFileUploadComponent } from './sc-formly-fields/field-file-upload/field-file-upload.component';
import { FieldFilesUploadComponent } from './sc-formly-fields/field-files-upload/field-files-upload.component';
import { FieldGoogleMapsComponent } from './sc-formly-fields/field-google-maps/field-google-maps.component';
import { FieldImageUploadComponent } from './sc-formly-fields/field-image-upload/field-image-upload.component';
import { FileUploadDirective } from './sc-formly-fields/field-image-upload/file-upload.directive';
import { FieldInlineEditComponent } from './sc-formly-fields/field-inline-edit/field-inline-edit.component';
import { FieldLinkComponent } from './sc-formly-fields/field-link/field-link.component';
import { FieldRadioCardComponent } from './sc-formly-fields/field-radio-card/field-radio-card.component';
import { FieldRepeatComponent } from './sc-formly-fields/field-repeat/field-repeat.component';
import { FieldSearchComponent } from './sc-formly-fields/field-search/field-search.component';
import { FieldSelectComponent } from './sc-formly-fields/field-select/field-select.component';
import { FieldTemplateComponent } from './sc-formly-fields/field-template/field-template.component';
import { FieldToggleComponent } from './sc-formly-fields/field-toggle/field-toggle.component';
import { WrapperBorderComponent } from './sc-formly-fields/wrapper-border/wrapper-border.component';
import { WrapperCarComponent } from './sc-formly-fields/wrapper-car/wrapper-car.component';
import { WrapperCardComponent } from './sc-formly-fields/wrapper-card/wrapper-card.component';
import { WrapperReadonlyComponent } from './sc-formly-fields/wrapper-readonly/wrapper-readonly.component';
import { ScAdvSearchComponent } from './sc-adv-search/sc-adv-search.component';
import { AutocompleteFieldComponent } from './form-fields/autocomplete-field/autocomplete-field.component';
import { AutocompleteOptionsPipe } from './form-fields/autocomplete-field/autocomplete-options.pipe';
import { CheckboxComponent } from './form-fields/checkbox/checkbox.component';
import { DaterangeComponent } from './form-fields/daterange/daterange.component';
import { DatetimePickerComponent } from './form-fields/datetime-picker/datetime-picker.component';
import { DragAndDropComponent } from './form-fields/drag-and-drop/drag-and-drop.component';
import { DragAndDropDirective } from './form-fields/drag-and-drop/drag-and-drop.directive';
import { DropBoxUploadComponent } from './form-fields/drop-box-upload/drop-box-upload.component';
import { ExternalFetchPipe } from './form-fields/external-fetch.pipe';
import { GenericFieldComponent } from './form-fields/generic-field/generic-field.component';
import { GoogleMapSearchComponent } from './form-fields/google-map-search/google-map-search.component';
import { ImageLinkPipe } from './form-fields/image-link.pipe';
import { NumberFieldComponent } from './form-fields/number-field/number-field.component';
import { RadioListFieldComponent } from './form-fields/radio-list-field/radio-list-field.component';
import { UppercaseDirective } from './form-fields/search/input-uppercase';
import { SearchComponent } from './form-fields/search/search.component';
import { SlideToggleFieldComponent } from './form-fields/slide-toggle-field/slide-toggle-field.component';
import { ScGenericFormComponent } from './sc-generic-form.component';
import { addonsExtension } from './misc/addons.extention';
import { FormlyWrapperAddons } from './misc/addons.wrappers';
import { applyEmailValidation, emailExpressionValidator } from './misc/email-extention';
import { FieldOptionsPipe } from './misc/field-options.pipe';
import { readonlyExtension } from './misc/readonly-extension';
import { registerTranslateExtension } from './misc/translate.extension';
import { ParsePropPipe } from './misc/parse-prop.pipe';

@NgModule({
  declarations: [
    ScGenericFormComponent,
    ExternalFetchPipe,
    DatetimePickerComponent,
    CheckboxComponent,
    GoogleMapSearchComponent,
    SearchComponent,
    DragAndDropComponent,
    DropBoxUploadComponent,
    DragAndDropDirective,
    UppercaseDirective,
    RadioListFieldComponent,
    AutocompleteFieldComponent,
    AutocompleteOptionsPipe,
    SlideToggleFieldComponent,
    NumberFieldComponent,
    FieldCheckboxComponent,
    GenericFieldComponent,
    ScAdvSearchComponent,
    ImageLinkPipe,
    FieldSearchComponent,
    FieldInlineEditComponent,
    FieldAutocompleteComponent,
    FieldDatetimePickerComponent,
    FieldRepeatComponent,
    FieldToggleComponent,
    WrapperCarComponent,
    WrapperReadonlyComponent,
    FieldDynamicComponent,
    WrapperBorderComponent,
    FormlyWrapperAddons,
    FieldImageUploadComponent,
    FileUploadDirective,
    WrapperCardComponent,
    AutocompleteValueParserPipe,
    FieldRadioCardComponent,
    FieldTemplateComponent,
    FieldFilesUploadComponent,
    FieldGoogleMapsComponent,
    FieldButtonToggleComponent,
    FieldLinkComponent,
    FieldFileUploadComponent,
    DaterangeComponent,
    FieldOptionsPipe,
    FieldSelectComponent,
    ParsePropPipe
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDatetimepickerModule,
    ScWidgetModule,
    NgxFileUploadModule,
    AgmCoreModule,
    MatGoogleMapsAutocompleteModule,
    MatProgressBarModule,
    MatRadioModule,
    MatSlideToggleModule,
    FlexLayoutModule,
    TranslateModule,
    MatProgressSpinnerModule,
    FilePickerModule,
    FormlyMatDatepickerModule,
    MatTooltipModule,
    FormlyMatToggleModule,
    MatCardModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    MatDatepickerModule,
    MatPseudoCheckboxModule,
    FormlyMaterialModule,
    MatNativeDateModule,
    FormlyModule.forRoot({
      wrappers: [
        { name: 'inline', component: FieldInlineEditComponent },
        { name: 'border', component: WrapperBorderComponent },
        { name: 'readonly', component: WrapperReadonlyComponent },
        { name: 'card', component: WrapperCardComponent },
        { name: 'addons', component: FormlyWrapperAddons }
      ],
      extensions: [
        { name: 'email', extension: { prePopulate: applyEmailValidation } },
        { name: 'readonly', extension: { onPopulate: readonlyExtension } },
        { name: 'addons', extension: { postPopulate: addonsExtension } }
      ],
      validationMessages: [{ name: 'required', message: 'This field is required' }],
      types: [
        { name: 'template', component: FieldTemplateComponent },
        {
          name: 'dynamic',
          component: FieldDynamicComponent,
          wrappers: []
        },
        {
          name: 'daterange',
          component: DaterangeComponent,
          wrappers: ['form-field']
        },
        {
          name: 'button',
          component: FieldLinkComponent,
          wrappers: [],
          defaultOptions: {
            templateOptions: {
              btnType: 'default',
              type: 'button'
            }
          }
        },
        {
          name: 'button-toggle',
          component: FieldButtonToggleComponent
        },
        { name: 'repeat', component: FieldRepeatComponent },
        { name: 'radio-card', component: FieldRadioCardComponent },
        {
          name: 'autocomplete',
          component: FieldAutocompleteComponent,
          wrappers: ['form-field']
        },
        {
          name: 'image-upload',
          component: FieldImageUploadComponent,
          wrappers: []
        },
        {
          name: 'file-upload',
          component: FieldFileUploadComponent,
          wrappers: []
        },
        {
          name: 'files-upload',
          component: FieldFilesUploadComponent,
          wrappers: []
        },
        {
          name: 'datetime',
          component: FieldDatetimePickerComponent
        },
        {
          name: 'search',
          component: FieldSearchComponent
        },
        {
          name: 'toggle',
          component: FieldToggleComponent,
          defaultOptions: {
            className: 'sc-toggle'
          }
        },
        {
          name: 'google-maps',
          component: FieldGoogleMapsComponent,
          wrappers: []
        },
        { name: 'select', component: FieldSelectComponent },
        { name: 'checkbox', component: FieldCheckboxComponent },
        { name: 'generic', component: GenericFieldComponent },
        { name: 'string', extends: 'input' },
        {
          name: 'number',
          extends: 'input',
          defaultOptions: {
            templateOptions: {
              type: 'number'
            }
          }
        },
        {
          name: 'email',
          extends: 'input',
          defaultOptions: {
            templateOptions: {
              type: 'email'
            },
            validators: {
              email: {
                expression: emailExpressionValidator,
                message: `This value is not a valid email.`
              }
            }
          }
        }
      ]
    })
  ],
  exports: [
    ScGenericFormComponent,
    DatetimePickerComponent,
    CheckboxComponent,
    SearchComponent,
    DragAndDropComponent,
    DropBoxUploadComponent,
    ScAdvSearchComponent,
    FormlyMaterialModule,
    MatNativeDateModule,
    MatDatepickerModule
  ],
  providers: [
    {
      provide: FORMLY_CONFIG,
      multi: true,
      useFactory: registerTranslateExtension,
      deps: [TranslateService]
    }
  ],
  entryComponents: []
})
export class ScGenericFormModule {}
